// extracted by mini-css-extract-plugin
export var showcaseWrapper = "showcase-module--showcaseWrapper--LY0aU";
export var readMoreButton = "showcase-module--readMoreButton--OA+Vu";